module.exports = __webpack_public_path__ + "static/media/29ADMSPC16.ebeb48c2.jpg";